<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton
                title="Payroll Advice Edit"
                :showAddNew="false"
                :showBtn="true"
                @onClickCloseButton="navigateToListPage"
            />
        </div>

      <div class="my-2 px-2">
        <div class="d-flex justify-content-between">
          <div>
             <h6>Payment Category: {{ paymentModeData.payment_mode_name }}</h6>
             <h6>Total Payable: {{ paymentModeData.total_payable_amount }}</h6>
             <h6>Total Paid: {{ paymentModeData.total_paid_amount }}</h6>
             <h6>Total Due: {{ paymentModeData.total_due_amount }}</h6>
          </div>
          <div>
            <div class="mb-1 col-12">
              <label for="colFormLabel" class="col-form-label">Payment Date</label>
              <vField
                  v-model="formData.payment_date"
                  name="date"
                  id="date"
                  type="date"
                  class="form-control"
              />
            </div>
            <button
                style="min-width: 64px;"
                :disabled="loading"
                @click="storeData"
                class="btn btn-primary btn-block waves-effect waves-float waves-light"
            >Save
            </button>
          </div>
        </div>
      </div>

        <div class="col-12 px-2 mt-2 mb-4">
          <div class="card" style="min-height: 200px">
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                <tr>
                  <th>Employee Name</th>
                  <th>Net Payable</th>
                  <th>Already Paid Amount</th>
                  <th>Paid Amount</th>
                  <th>Due Amount</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in payrollData.generals" :key="i">
                  <td>{{ item.employee_name + '(' + item.serial_no + ')' }}</td>
                  <td class="text-right">{{ item.total_payable_amount }}</td>
                  <td class="text-right">{{ item.total_paid_amount }}</td>
                  <td>
                    <input
                        type="number"
                        v-model.number="item.paid_amount"
                        @input="updatePayment(item)"
                        class="form-control "
                    />
                  </td>
                  <td>
                     {{ getDueAmount(item) }}
                  </td>
                </tr>
                </tbody>
              </table>
              <p v-if="payrollData && payrollData.length < 0" class="text-center mt-5">No data</p>
            </div>
          </div>
        </div>

        <Loader v-if="loading"/>

    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import {inject, onMounted, reactive, ref} from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import { computed } from 'vue';
import figureFormatter from "@/services/utils/figureFormatter";

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
let saveButtonLoader = ref(false)
const payrollData = ref([]);
const paymentModeData = ref('');
const payrollStatementId = ref('');
const paymentModeId = ref('');
const params = ref({
    offset: 20,
});
const { commaFormat } = figureFormatter();
const token = computed(() => localStorage.getItem('token'));
const {
  fetchSinglePayrollAdviceMaster,
} = handleHrPayroll()

const formData = ref({
  payment_date: '',
  id: '',
  payments: []
})

const getPayrollData = async () => {
  let query = getQuery();
  let payrollMasterId = route.params.payrollMasterId;

  await fetchSinglePayrollAdviceMaster(payrollMasterId, query).then(res => {
    if (!res.status){
      return
    }

    let data = res.data.data;
    payrollStatementId.value = data.payroll_statement_id;
    paymentModeId.value = data.payment_mode_id;
    payrollData.value = data;
    paymentModeData.value = res.data.details;
    formData.value.id = data.id;
    formData.value.payment_date = data.payment_date;

    formData.value.payments = data.generals
          .map(item => ({
            id: item.id,
            contact_profile_id: item.contact_profile_id,
            paid_amount: item.paid_amount
          }))

  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const storeData = async () => {
  let query = getQuery();

  loading.value = true;
  if (!formData.value.payment_date) {
    showError('Please select a payment date.')
    loading.value = false;
    return
  }
  if (formData.value.payments.length === 0) {
    showError('Please enter at least one paid amount.')
    loading.value = false;
    return
  }
}

const getDueAmount = (item) => {
  return item.total_payable_amount - (item.total_paid_amount - item.already_paid_amount) - (item.paid_amount)
}

const updatePayment = (item) => {
  const maxAmount = item.total_payable_amount - item.total_paid_amount + item.already_paid_amount;

  if (item.paid_amount > maxAmount) {
    showError(`You cannot pay more than the remaining amount of ${maxAmount}.`);
    const existing = formData.value.payments.find(p => p.id === item.id)
    existing.paid_amount = existing ? maxAmount : 0
    item.paid_amount = existing ? maxAmount : 0
    return
  }

  if (item.paid_amount < 0) {
    showError(`Paid Amount cannot be negative.`);
    item.paid_amount = 0;
    return;
  }

  const existing = formData.value.payments.find(p => p.id === item.id)
  if (existing) {
    existing.paid_amount = item.paid_amount
  }
}

const navigateToListPage = () => {
  let param = {
    companyId: route.params.companyId,
    moduleId: route.params.moduleId,
    menuId: route.params.menuId,
    pageId: route.params.pageId,
    payrollStatementId:payrollStatementId.value,
    paymentModeId:paymentModeId.value
  }

  let query = route.query;

  router.push({
    name:  'payroll-advice-list',
    params: param,
    query: query
  })
}

function getQuery() {
  return `?company_id=${route.params.companyId}`;
}

onMounted(() => {
    Promise.all([
      getPayrollData(),
    ])
})
</script>
